import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import type { RowRenderProps } from 'react-table';

import type { FlavorKeys } from '@feathr/blackbox';
import { Pill } from '@feathr/components';
import { flavorColor, flavorIcon } from '@feathr/report_components';

import { getDescription } from './FlavorChip.utils';

interface IProps extends RowRenderProps {
  flavor: FlavorKeys;
}

function FlavorChip({ flavor }: Readonly<IProps>): JSX.Element {
  const flvr = flavor || 'custom';
  const icon = flavorIcon(flvr);
  const color = flavorColor(flvr);
  const description = getDescription(flvr);
  return (
    <Pill prefix={<FontAwesomeIcon icon={icon} />} theme={color} truncate={false}>
      {description}
    </Pill>
  );
}

export default FlavorChip;
